export enum UserRole {
    REOPS_ADMIN = 'ReOps Admin',
    PMC_ADMIN = 'PMC Admin',
    PROPERTY_ADMIN = 'Property Admin',
    PROPERTY_MANAGER = 'Property Manager',
    MAINTENANCE_SUPERVISOR = 'Maintenance Supervisor',
    MAINTENANCE_TECHNICIAN = 'Maintenance Technician',
    TEST_NOT_EXISTING_ROLE = 'Not Existing role for tests',
}

export enum UserStatus {
    INVITED = 'Invited',
    SUSPENDED = 'Suspended',
    UNSUSPENDED = 'Unsuspended',
}

export enum UserPermissions {
    // Catalog
    // Add / rename / delete categories in the property catalog
    EDIT_CATALOG_CATEGORIES = 'API_EDIT_PROPERTY_CATALOG',
    // Add / remove items to the property catalog; access global catalog browse
    MANAGE_CATALOG_ITEMS = 'API_MANAGE_CATALOG_ITEMS',
    API_DOWNLOAD_LABELS = 'API_DOWNLOAD_LABELS',

    // Order item
    ADD_ORDER_ITEM = 'add_orderitem',
    VIEW_ORDER_ITEM = 'view_orderitem',
    DELETE_ORDER_ITEM = 'delete_orderitem',
    CHANGE_ORDER_ITEM = 'change_orderitem',
    CAN_SEE_PRICES = 'API_CAN_SEE_PRICES',

    //Order
    EDIT_PENDING_APPROVAL_ORDER = 'API_EDIT_PENDING_APPROVAL_ORDER',
    EDIT_IN_REVIEW_ORDER = 'API_EDIT_IN_REVIEW_ORDER',
    REJECT_ORDER = 'API_REJECT_ORDER',
    APPROVE_ORDER = 'API_APPROVE_ORDER',
    ADD_ORDER = 'add_order',
    MOVE_ORDER_TO_PENDING_APPROVAL = 'API_TO_PENDING_APPROVAL_ORDER',

    // Reports
    API_SEE_SAVINGS_INSIGHTS = 'API_SEE_SAVINGS_INSIGHTS',
    API_SEE_SPEND_INSIGHTS = 'API_SEE_SPEND_INSIGHTS',
}

export const APP_ROLES: UserRole[] = [
    UserRole.PMC_ADMIN,
    UserRole.PROPERTY_ADMIN,
    UserRole.PROPERTY_MANAGER,
    UserRole.MAINTENANCE_SUPERVISOR,
    UserRole.MAINTENANCE_TECHNICIAN,
];

export const ADMIN_OR_MANAGER_ROLES: UserRole[] = [
    UserRole.PMC_ADMIN,
    UserRole.PROPERTY_ADMIN,
    UserRole.PROPERTY_MANAGER,
];

export const REPORTS_ROLES: UserRole[] = [
    UserRole.PMC_ADMIN,
    UserRole.PROPERTY_ADMIN,
    UserRole.PROPERTY_MANAGER,
    UserRole.MAINTENANCE_SUPERVISOR,
];

export const acceptableRolesForApp = APP_ROLES;

export const isAdminOrManagerRole = (role?: UserRole): boolean =>
    role != null && ADMIN_OR_MANAGER_ROLES.includes(role);
